<template>
    <div class="mb-4 overflow-hidden">
        <div class="mb-3.5 shine" />
        <div class="mb-3.5 shine w-1/4" />
        <div class="mb-3.5 shine" />
        <div class="mb-3.5 shine w-3/5" />
    </div>
</template>
<style scoped>
.shine {
    @apply rounded-lg;
}
</style>
